import { applyElevation, ElevationMultiplier, neutralForegroundRest, neutralLayerL1, } from "@microsoft/fast-components-styles-msft";
import { directionSwitch } from "@microsoft/fast-jss-utilities";
const styles = {
    "@keyframes SiteNavigationClose": {
        "0%": {
            opacity: 1,
            transform: "scaleX(1)",
        },
        "100%": {
            opacity: 0,
            transform: "scaleX(0.93)",
        },
    },
    "@keyframes SiteNavigationOpen": {
        "0%": {
            opacity: 0,
            transform: "scaleX(0.93)",
        },
        "100%": {
            opacity: 1,
            transform: "scaleX(1)",
        },
    },
    "@keyframes TitleClose": {
        "0%": {
            opacity: 1,
        },
        "100%": {
            opacity: 0,
        },
    },
    "@keyframes TitleOpen": {
        "0%": {
            opacity: 0,
        },
        "100%": {
            opacity: 1,
        },
    },
    sidePaneLayout: {},
    sidePaneLayout_canvas: {
        "overflow-y": "auto",
        "padding-top": "30px",
        "padding-left": directionSwitch("44px", "84px"),
        "padding-right": directionSwitch("84px", "44px"),
        color: neutralForegroundRest,
        "@media only screen and (max-width: 1035px)": {
            "padding-left": "46px",
            "padding-right": "46px",
        },
    },
    sidePaneLayout_container: {},
    sidePaneLayout_mobileNavigationMenu: Object.assign({ display: "none", "flex-direction": "column", position: "absolute", "z-index": "100", top: "0", left: directionSwitch("0", "auto"), right: directionSwitch("auto", "0"), height: "100vh", width: "320px", "padding-top": "20px", "padding-left": directionSwitch("40px", "20px"), "padding-right": directionSwitch("20px", "40px"), "animation-fill-mode": "both", "transform-origin": directionSwitch("top left", "top right") }, applyElevation(ElevationMultiplier.e4), { "@media only screen and (max-width: 1035px)": {
            height: "100%",
        } }),
    sidePaneLayout_mobileNavigationMenu__close: {
        "animation-name": "SiteNavigationClose",
        "animation-duration": ".25s",
        "transition-timing-function": "cubic-bezier(.26,1,.48,1)",
        "& $sidePaneLayout_navigation_headerText": {
            "animation-duration": ".25s",
            "animation-name": "TitleClose",
        },
    },
    sidePaneLayout_mobileNavigationMenu__open: {
        "animation-duration": ".25s",
        "animation-name": "SiteNavigationOpen",
        "transition-timing-function": "cubic-bezier(.52,0,.74,0)",
        "& $sidePaneLayout_navigation_headerText": {
            "animation-duration": ".25s",
            "animation-delay": ".075s",
            "animation-fill-mode": "both",
            "animation-name": "TitleOpen",
        },
    },
    sidePaneLayout_mobileNavigationMenu_button: {
        display: "none",
        "min-width": "32px",
        "margin-right": directionSwitch("10px", "unset"),
        "margin-left": directionSwitch("unset", "10px"),
        "@media only screen and (max-width: 1035px)": {
            display: "block",
        },
    },
    sidePaneLayout_mobileNavigationMenu_buttonContainer: {
        position: "relative",
    },
    sidePaneLayout_icon: {
        height: "16px",
        width: "16px",
    },
    sidePaneLayout_globalActionsButton: {
        "min-width": "32px",
    },
    sidePaneLayout_globalActions: Object.assign({ "z-index": "3", position: "absolute", color: neutralForegroundRest, background: neutralLayerL1, padding: "4px 4px 4px 3px", "min-width": "240px", top: "44px", right: "0" }, applyElevation(ElevationMultiplier.e4)),
    sidePaneLayout_navigation: {
        flex: "1",
        "list-style-type": "none",
        padding: "0",
        "margin-top": "10px",
        "min-width": "280px",
        "overflow-y": "auto",
        "margin-bottom": "40px",
        color: neutralForegroundRest,
        "@media only screen and (max-width: 1035px)": {
            display: "none",
        },
    },
    sidePaneLayout_mobileNavigation: {
        display: "none",
        "flex-direction": "column",
        flex: "1",
        padding: "0",
        width: "100%",
        "list-style-type": "none",
        "margin-right": directionSwitch("20px", "unset"),
        "margin-left": directionSwitch("unset", "20px"),
        "margin-top": "10px",
        "min-width": "150px",
        color: neutralForegroundRest,
        "@media only screen and (max-width: 1035px)": {
            display: "flex",
        },
    },
    sidePaneLayout_mobileNavigation_headerContainer: {
        display: "flex",
        "margin-bottom": "20px",
    },
    sidePaneLayout_mobileNavigation_container: {
        display: "none",
        "flex-direction": "column",
        width: "100%",
        height: "100%",
        "overflow-y": "auto",
        "margin-bottom": "20px",
        "@media only screen and (max-width: 1035px)": {
            display: "flex",
        },
    },
    sidePaneLayout_navigation_header: {
        display: "flex",
    },
    sidePaneLayout_navigation_headerText: {
        opacity: "1",
    },
    sidePaneLayout_navigation_headerContainer: {
        display: "flex",
        "align-items": "center",
        "justify-content": "space-between",
        "min-height": "38px",
    },
    sidePaneLayout_pane: {
        display: "flex",
        "flex-direction": "column",
        "padding-top": "30px",
        "padding-left": directionSwitch("84px", "42px"),
        "padding-right": directionSwitch("42px", "84px"),
        height: "100vh",
        "@media only screen and (max-width: 1035px)": {
            "flex-direction": "row",
            "align-items": "center",
            "padding-left": "46px",
            "padding-right": "46px",
            "max-width": "820px",
            height: "unset",
        },
    },
    sidePaneLayout_row: {
        "@media only screen and (max-width: 1035px)": {
            display: "block",
            "overflow-y": "auto",
        },
    },
    sidePaneLayout_textField: {
        "margin-top": "10px",
        "@media only screen and (max-width: 1035px)": {
            "min-width": "240px",
            "margin-right": directionSwitch("unset", "auto"),
            "margin-left": directionSwitch("auto", "unset"),
            "margin-top": "unset",
        },
    },
    sidePaneLayout__inPageFlow: {
        "& $sidePaneLayout_mobileNavigationMenu, & $sidePaneLayout_pane": {
            height: "auto",
        },
        "& $sidePaneLayout_container": {
            display: "block",
            width: "auto",
            height: "auto",
        },
    },
};
export default styles;
